module.exports = __webpack_public_path__ + "media/components/country-flag/static/kp-1f68abd59ec41579ca2fb8ff0a47529e.svg";